/* Home product rows (sections/home-product-list.liquid): prev/next arrows for the sideways-scrolling row.
   Each click moves by the number of whole cards in view. Arrows disable at the ends. */
(function () {
  if (window.__homeProductList) return;
  window.__homeProductList = true;

  function setup(root) {
    (root || document).querySelectorAll('.hpl').forEach(function (s) {
      var grid = s.querySelector('.hpl__grid');
      var prev = s.querySelector('.hpl__arrow--prev');
      var next = s.querySelector('.hpl__arrow--next');
      if (!grid || !prev || !next || s.__hpl) return;
      s.__hpl = true;

      function update() {
        var max = grid.scrollWidth - grid.clientWidth - 2;
        prev.disabled = grid.scrollLeft <= 2;
        next.disabled = grid.scrollLeft >= max;
      }
      function step(dir) {
        var item = grid.querySelector('.hpl__item');
        var gap = parseFloat(getComputedStyle(grid).columnGap) || 0;
        var w = item ? item.getBoundingClientRect().width + gap : grid.clientWidth;
        var n = Math.max(1, Math.floor(grid.clientWidth / w));
        grid.scrollBy({ left: dir * n * w, behavior: 'smooth' });
      }
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      grid.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
  setup();
})();
